export const url = "/api/v1.0/config";